import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';

import { FuseSidebarModule } from './../../../../@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from './../../../../@fuse/shared.module';

import { ChatPanelModule } from './../../components/chat-panel/chat-panel.module';
import { ContentModule } from './../../components/content/content.module';
import { FooterModule } from './../../components/footer/footer.module';
import { NavbarModule } from './../../components/navbar/navbar.module';
import { QuickPanelModule } from './../../components/quick-panel/quick-panel.module';
import { QuickPanelComponent } from './../../components/quick-panel/quick-panel.component';
import { ToolbarModule } from './../../components/toolbar/toolbar.module';
import { ToolbarComponent } from './../../components/toolbar/toolbar.component';
import { PlatformBreadCrumbModule } from '@ecap3/app-platform-breadcrumb';
import { HorizontalLayout1Component } from './../../horizontal/layout-1/layout-1.component';
import { PlatformBreadcrumbSharedModule } from '@ecap3/app-platform-breadcrumb-shared-module';
@NgModule({
    declarations: [
        HorizontalLayout1Component
    ],
    imports: [
        PlatformBreadCrumbModule,
        PlatformBreadcrumbSharedModule,
        MatSidenavModule,
        FuseSharedModule,
        FuseSidebarModule,
        ChatPanelModule,
        ContentModule,
        FooterModule,
        NavbarModule,
        QuickPanelModule,
        ToolbarModule
    ],
    exports: [
        HorizontalLayout1Component
    ]
})
export class HorizontalLayout1Module
{
}
